'use strict';

ixModuleRouting("impactx.user", {
    "/resplist": {
        template: "<ixa-resp-list></ixa-resp-list>",
        process: "EditUserResponsibilities",
        workspace: "admin",
    },
    "/resp/:id": {
        template: "<ixa-resp-dialog></ixa-resp-dialog>",
        process: "EditUserResponsibilities",
        workspace: "admin",
    },
    "/afterlogininput": {
        template: "<ixa-after-login-dialog></ixa-after-login-dialog>",
        process: "EditDataAfterLogin",
        workspace: "shop",
    },
    "/anonymizationresult/:prepId": {
        template: "<ixa-anonymization-result-dialog></ixa-anonymization-result-dialog>",
        process: "DoAnonymization",
        workspace: "shop",
    }
});
